/**
 * Created by cedricgodefroy on 17/08/2017.
 */
angular.module('FlexyBeautyApp.services')
    .factory('CompanyImageFormat', [function () {
        let companyImageFormat = {
            SQUARE: {id: 'SQUARE', label: 'square'},
            RECT: {id: 'RECT', label: 'rect'},
            PORTRAIT: {id: 'PORTRAIT', label: 'portrait'}
        };

        return companyImageFormat;

    }])
    .factory('IOSDevice', [function () {
        let iosDevices = {
            IPAD: {label: 'iPod'},
            IPOD: {label: 'iPad'},
            IPHONE: {label: 'iPhone'}
        };
        iosDevices.isIOSDevice = function () {
            if (navigator && navigator.platform && (navigator.platform.indexOf(this.IPAD.label) !== -1 || navigator.platform.indexOf(this.IPOD.label) !== -1 || navigator.platform.indexOf(this.IPHONE.label) !== -1))
                return true;
            return false;
        };
        return iosDevices;
    }])
    .factory('TreeMovementDirection', ["gettextCatalog", function (gettextCatalog) {
        let treeMovementDirection = {

            UP: {id: 'UP', action: gettextCatalog.getString("Remonter")},
            DOWN: {id: 'DOWN', action: gettextCatalog.getString("Descendre")}
        };

        return treeMovementDirection;

    }])
    .factory('AppCode', [function () {
        return {
            SMS_APP: "sms",
            SMS_ATTRIBUTE_HOUR_TO_SEND: "hourToSend",
            SMS_ATTRIBUTE_ENDING_TEXT: "endingText",
            SMS_ATTRIBUTE_FIRST_NAME: "firstName",
            POS_APP: "pos",
            POS_ATTRIBUTE_IZETTLE_PAYMENT: "iZettlePayment",
            WEBSITE_APP: "webSite",
            WEBSITE_ATTRIBUTE_ALLOW_CHOOSE_HR: "allowChooseHr",
        };
    }]);



// WEBPACK FOOTER //
// ./js/services/views/ViewConstants.js